import { IFullPlanDetail } from "../../../interfaces/api";
import SingleInfoBenefit from "./SingleInfoBenefit.component";
import {
  getDoubleDeepHMO,
  getSingleDeepHMO,
} from "../../../functions/planDetails";
import { useZipRootLoaderData } from "../../../hooks/useZipRootLoaderData";

const DataTableDetailHospital = ({ data }: { data: IFullPlanDetail }) => {
  const { selectedYear } = useZipRootLoaderData();
  const inpatientHospitalBenefit = getDoubleDeepHMO(
    data,
    "Inpatient Hospital",
    selectedYear === 2024
      ? "Inpatient Hospital-Acute"
      : "Inpatient Hospital Acute"
  );
  const outpatientHospitalObservationbenefit = getDoubleDeepHMO(
    data,
    "Outpatient Services",
    selectedYear === 2024
      ? "Outpatient Hospital Services and Observation Services"
      : "Outpatient hospital services"
  );
  const ambulatorySurgicalCenterbenefit = getDoubleDeepHMO(
    data,
    "Ambulatory Surgical Center",
    "Ambulatory Surgical Center (ASC) Services"
  );
  const preventiveCarebenefit = getDoubleDeepHMO(
    data,
    "Preventive Benefits",
    selectedYear === 2024
      ? "Medicare-covered Zero Dollar Preventive Services"
      : "Medicare-Covered Zero Dollar Preventive Services"
  );
  const emergencyCareBenefit =
    selectedYear === 2024
      ? getDoubleDeepHMO(
          data,
          "Emergency Care/ Post-Stabilization Care",
          "Emergency Services"
        )
      : getSingleDeepHMO(data, "Emergency Care/ Post-Stabilization Care");
  const urgentlyNeededServicesBenefit = getSingleDeepHMO(
    data,
    "Urgently Needed Services"
  );
  const proceduresTestesLabServicebenefit = getDoubleDeepHMO(
    data,
    "Outpatient Diagnostic",
    "Outpatient Diag Procs/Tests/Lab Services"
  );
  const xrayBenefit = getDoubleDeepHMO(
    data,
    "Outpatient Diagnostic",
    "Outpatient Diag/Therapeutic Rad Services"
  );
  // const diagnosticBenefit = getDoubleDeepHMO(
  //   data,
  //   "Outpatient Diagnostic",
  //   "Outpatient Diag Procs/Tests/Lab Services"
  // );
  const physicalSpeachTeraphyBenefit = getSingleDeepHMO(
    data,
    "Physical and Speech Therapy"
  );
  const groundAirServicesBenefit =
    selectedYear === 2024
      ? getDoubleDeepHMO(
          data,
          "Ground and Air Ambulance Services",
          "Ambulance Services (Ground and Air Ambulance Services)"
        )
      : getSingleDeepHMO(data, "Ground and Air Ambulance Services");
  const skilledNursingFacalityBenefit = getSingleDeepHMO(
    data,
    "Skilled Nursing Facility"
  );

  return (
    <div
      className="grid-x"
      style={{
        backgroundColor: "white",
        border: "1px solid #D3E1F0",
        textAlign: "left",
      }}
    >
      <SingleInfoBenefit
        benefit={inpatientHospitalBenefit}
        title="Inpatient Hospital - Acute"
      />
      <SingleInfoBenefit
        benefit={outpatientHospitalObservationbenefit}
        title="Outpatient Hospital & Observation"
      />
      <SingleInfoBenefit
        benefit={ambulatorySurgicalCenterbenefit}
        title="Ambulatory Surgical Center"
      />
      <SingleInfoBenefit
        benefit={preventiveCarebenefit}
        title="Preventive Care"
      />
      <SingleInfoBenefit
        benefit={emergencyCareBenefit}
        title="Emergency Care"
      />
      <SingleInfoBenefit
        benefit={urgentlyNeededServicesBenefit}
        title="Urgently Needed Services"
      />
      <SingleInfoBenefit
        benefit={proceduresTestesLabServicebenefit}
        title="Procedures, Tests, Lab Services"
      />
      <SingleInfoBenefit
        benefit={xrayBenefit}
        title="Outpatient Radiology"
        subtitle="(X-Ray, Diagnostic, and Therapeutic Radiology Services)"
      />
      <SingleInfoBenefit
        benefit={physicalSpeachTeraphyBenefit}
        title="Physical & Speech Therapy"
      />
      <SingleInfoBenefit
        benefit={groundAirServicesBenefit}
        title="Ground & Air Ambulance"
      />
      <SingleInfoBenefit
        benefit={skilledNursingFacalityBenefit}
        title="Skilled Nursing Facility"
      />
    </div>
  );
};

export default DataTableDetailHospital;
